/**
 * Accept a PIN the unlock keypad can enter, or the unchanged configured-PIN mask.
 * Default-PIN refusal remains enforced by the existing platform and form rules.
 * @since 1.1.11
 * @example isSettingsPinFormValue("4826") // true
 */
export function isSettingsPinFormValue(pin: string): boolean {
  return pin === "••••" || (pin.length >= 4 && pin.length <= 8 && !/[^0-9]/.test(pin));
}

/**
 * Allow the redaction mask only when the platform confirms an existing PIN.
 * @since 1.1.11
 * @example await validateSettingsPinMask("••••", async () => false) // "missing"
 */
export async function validateSettingsPinMask(
  pin: string,
  isPinConfigured: () => Promise<boolean>,
): Promise<"missing" | "unavailable" | undefined> {
  if (pin !== "••••") return undefined;
  try { return await isPinConfigured() ? undefined : "missing"; }
  catch { return "unavailable"; }
}
